var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0.5H1.5C1.10218 0.5 0.720645 0.658035 0.43934 0.93934C0.158036 1.22064 0 1.60218 0 2V14C0 14.3978 0.158036 14.7794 0.43934 15.0607C0.720645 15.342 1.10218 15.5 1.5 15.5H3C3.39782 15.5 3.77936 15.342 4.06066 15.0607C4.34196 14.7794 4.5 14.3978 4.5 14V2C4.5 1.60218 4.34196 1.22064 4.06066 0.93934C3.77936 0.658035 3.39782 0.5 3 0.5V0.5ZM10.5 0.5H9C8.60218 0.5 8.22064 0.658035 7.93934 0.93934C7.65804 1.22064 7.5 1.60218 7.5 2V14C7.5 14.3978 7.65804 14.7794 7.93934 15.0607C8.22064 15.342 8.60218 15.5 9 15.5H10.5C10.8978 15.5 11.2794 15.342 11.5607 15.0607C11.842 14.7794 12 14.3978 12 14V2C12 1.60218 11.842 1.22064 11.5607 0.93934C11.2794 0.658035 10.8978 0.5 10.5 0.5V0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pauseIcon.f10e6ae931a1e2f1a999f3bb2a626bec.svg";
export { ForwardRef as ReactComponent };